import {Cache} from "@/common/lib/cache/Cache";

class TeamList extends Cache {
    constructor() {
        super();
        this.key += '_team_list'
    }
}

export const teamListCache = new TeamList();
